export class ContentVoiceTalents {
	Id?: number;
	TalentGender: string;
	TalentName: string;

	name?: string;
}
